import {Component, Vue} from "vue-property-decorator";
import HeaderContainer from "@/components/HeaderContainer.vue";
import Wrapper from "@/components/Wrapper.vue";
import api from "@/services/apiService";
import FieldVerifications from "@/utils/FieldVerifications";
import {ErrorService} from "@/services/ErrorService";
import Toaster from "@/components/Toaster.vue";
import {ToasterType} from "@/types/ToasterConfig";
import {AxiosResponse} from "axios";
import {ClientAPIGlobalInterface, ClientAPIInterface} from "@/entity/Client";

@Component({
  components: {
    HeaderContainer,
    Wrapper,
    Toaster,
  },
})
export default class Administration extends Vue {

  public endpointAPI = "http://localhost/api"; // TODO: changer en prod

  public newClient = {
    name: '',
    address: '',
    phone: '',
    totalQuota: '',
  };

  public newUser = {
    email: '',
    lastName: '',
    firstName: '',
    client: '',
  };

  public newPassword = {
    email: '',
  }

  public clients: ClientAPIInterface[] = [];

  mounted() {
    this.loadClients();
  }

  createClientEvent() {
    if (this.checkNewClientErrors()) return;

    api.authRequest.post("/clients", {
      name: this.newClient.name,
      address: this.newClient.address,
      phone: this.newClient.phone,
      totalQuota: parseInt(this.newClient.totalQuota),
    }).then((response) => {
      this.resetClient();
      this.$store.commit('updateToaster', {
        type: ToasterType.Green,
        message: 'Nouveau client créé avec succès.',
      });
      this.loadClients();
    }).catch((error) => {
      ErrorService.dealWithTheError(error);
    });
  }

  createUserEvent() {
    if (this.checkNewUserErrors()) return;

    api.authRequest.post("/users", {
      email: this.newUser.email,
      password: 'newUser',
      lastName: this.newUser.lastName,
      firstName: this.newUser.firstName,
      client: this.newUser.client,
    }).then((response) => {
      this.resetPassword(this.newUser.email, true);
      this.resetNewUser();
      this.$store.commit('updateToaster', {
        type: ToasterType.Green,
        message: 'Nouvel utilisateur créé avec succès.',
      });
    }).catch((error) => {
      ErrorService.dealWithTheError(error);
    });
  }

  resetPasswordEvent() {
    if (this.checkNewPasswordErrors()) return;
    this.resetPassword(this.newPassword.email, false);
  }

  resetPassword(email: string = '', isAfterNewUser: boolean = false) {
    api.authRequest.post("/login/forgotten-password", {
      email: email,
    }).then((response) => {
      if (!isAfterNewUser) this.resetNewPassword();
      this.$store.commit('updateToaster', {
        type: ToasterType.Green,
        message: (isAfterNewUser) ? 'Nouvel utilisateur créé avec succès. Un mail a été envoyé pour changer le mot de passe.' : 'Mot de passe remis à zéro avec succès.',
      });
    }).catch((error) => {
      ErrorService.dealWithTheError(error);
    });
  }

  sendSummaryMailEvent() {
    api.authRequest.get("/mails/summary")
      .then((response) => {
        this.$store.commit('updateToaster', {
          type: ToasterType.Green,
          message: 'Mail envoyé avec succès.',
        });
      }).catch((error) => {
      ErrorService.dealWithTheError(error);
    });
  }

  checkNewClientErrors(): boolean {
    let isError = false;
    isError = FieldVerifications.isDefine(this.newClient.name) ? isError : true;
    isError = FieldVerifications.isDefine(this.newClient.address) ? isError : true;
    isError = FieldVerifications.isDefine(this.newClient.phone) ? isError : true;
    isError = FieldVerifications.isDefine(this.newClient.totalQuota) ? isError : true;

    return isError;
  }

  checkNewUserErrors(): boolean {
    let isError = false;
    isError = FieldVerifications.isDefine(this.newUser.lastName) ? isError : true;
    isError = FieldVerifications.isDefine(this.newUser.firstName) ? isError : true;
    isError = FieldVerifications.isDefine(this.newUser.email) ? isError : true;
    isError = FieldVerifications.isDefine(this.newUser.client) ? isError : true;

    return isError;
  }

  checkNewPasswordErrors(): boolean {
    let isError = false;
    isError = FieldVerifications.isDefine(this.newPassword.email) ? isError : true;

    return isError;
  }

  resetClient() {
    this.newClient.name = '';
    this.newClient.address = '';
    this.newClient.phone = '';
    this.newClient.totalQuota = '';
  }

  resetNewUser() {
    this.newUser.email = '';
    this.newUser.lastName = '';
    this.newUser.firstName = '';
    this.newUser.client = '';
  }

  resetNewPassword() {
    this.newPassword.email = '';
  }

  loadClients() {
    api.authRequest.get("/clients")
      .then((response: AxiosResponse<ClientAPIGlobalInterface>) => {
        // @ts-ignore
        this.clients = response["hydra:member"];
      }).catch((error) => {
      ErrorService.dealWithTheError(error);
    });
  }

}
